var $77ac944da51b7354$exports = {};
// Get all the elements to be parallaxed
const $77ac944da51b7354$var$parallaxElements = document.querySelectorAll(".lax");
//const logo_img = $('.header-logo').attr('src');
const $77ac944da51b7354$var$logo_img = document.getElementById("logo");
const $77ac944da51b7354$var$logo_filename = $77ac944da51b7354$var$logo_img.src.slice(0, -4); // strip extenstion
// The parallax function
const $77ac944da51b7354$var$parallax = (elements)=>{
    if ("undefined" !== elements && elements.length > 0) elements.forEach((element)=>{
        let windowHeight = window.innerHeight;
        let topOffset = element.getBoundingClientRect().top;
        let elementHeight = element.getBoundingClientRect().height;
        let y = topOffset + elementHeight;
        // only scroll if it's visible in viewport
        if (y > 0 && topOffset < windowHeight) {
            var coords = "0% " + 0.25 * window.scrollY + "px";
            element.style.backgroundPosition = coords;
        }
    });
};
//Call the function on scroll
window.onscroll = ()=>{
    $77ac944da51b7354$var$parallax($77ac944da51b7354$var$parallaxElements);
    if (window.scrollY >= 200) {
        document.getElementsByTagName("header")[0].classList.add("bg-primary");
        $77ac944da51b7354$var$logo_img.src = $77ac944da51b7354$var$logo_filename + "-white.png";
    } else {
        document.getElementsByTagName("header")[0].classList.remove("bg-primary");
        $77ac944da51b7354$var$logo_img.src = $77ac944da51b7354$var$logo_filename + ".png";
    }
};


//# sourceMappingURL=index.b35ffbfe.js.map
